import React from 'react';
import { borderColor } from '../../Utilities/utils/Theming';
import { styled } from '../../Themes';
import { MIcon } from '../Icon';
import { TYPE } from './types';

export const CheckboxOn = styled('span', ({ ishighlighted, $theme }: any) => {
	return {
		display: 'flex',
		height: '18px',
		width: '18px',
		...borderColor('var(--epods--color-bluegrey-500)'),
		borderWidth: '1px',
		borderStyle: 'solid',
		boxShadow: 'none',
		borderRadius: 'var(--epods--border-radius)',
		backgroundColor: ishighlighted ? 'var(--epods--color-bg-primary-hover)' : 'var(--epods--color-bg-primary)',
		marginRight: '8px',
		paddingLeft: '0px',
	};
});

export const CheckboxOff = styled('span', ({ ishighlighted, $theme }: any) => {
	return {
		display: 'flex',
		height: '18px',
		width: '18px',
		...borderColor('var(--epods--color-bluegrey-500)'),
		borderWidth: '1px',
		borderStyle: 'solid',
		boxShadow: 'white 0px 0px 0px 2px inset',
		borderRadius: 'var(--epods--border-radius)',
		backgroundColor: ishighlighted ? 'var(--epods--color-bg-inactive-boxes-hover)' : 'var(--epods--color-bg-inactive-boxes)',
		marginRight: '8px',
		paddingLeft: '0px',
	};
});

export const presets = (option: any, multiPlaceholder: string = "Item(s) selected") => {
	return {
		select: {
			searchable: false,
			clearable: false,
		},

		combo: {
			searchable: true,
			backspaceRemoves: true,
			clearable: true,
			creatable: false,
			closeOnSelect: true,
			deleteRemoves: true,
			escapeClearsValue: true,
			openOnClick: true,
		},

		'multi-tags': {
			searchable: false,
			clearable: false,
			multi: true,
			filterOutSelected: true,
			closeOnSelect: true,
		},

		multi: {
			escapeClearsValue: true,
			openOnClick: true,
			creatable: false,
			backspaceRemoves: true,
			deleteRemoves: true,
			searchable: true,
			clearable: false,
			multi: true,
			filterOutSelected: false,
			closeOnSelect: false,
			textMultiSummary: <span>{multiPlaceholder}</span>,
			placeholder: 'Select...',
			badge: true,
			itemBefore: {
				default: (
					<CheckboxOff ishighlighted={option?.isHighlighted ? 'true' : undefined}>
						<MIcon icon="check" color="transparent" size="16px" />
					</CheckboxOff>
				),
				selected: (
					<CheckboxOn ishighlighted={option?.isHighlighted ? 'true' : undefined}>
						<MIcon icon="check" color="var(--epods--color-text-inverted)" size="16px" />
					</CheckboxOn>
				),
			},
		},

		creatable: {
			type: TYPE.search,
			clearable: true,
			creatable: true,
		},
	};
};
